const initialState = { rounds: [], structure: "", adminId: "" };

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case 'editRounds':
            return { data: action.rounds, structure: action.structure, adminId: action.adminId };
        default:
            return state;
    }
}
export default reducer;